import React from 'react'
import Footer from '../../Components/Footer'
import Header from '../../Components/Header'
import Sidebar from '../../Components/Sidebar'
import UpdateAccordian from './update'

const index = () => {
  return (
        <React.Fragment>
                <div className='wrapper'>
                    <Header/>
                    <Sidebar/>
                    <UpdateAccordian/>
                    <Footer/>
                </div>

        </React.Fragment>
    )
}

export default index